import { createAsyncActionCreator, IAsyncActionCreator } from '../store/actions/createActionCreator';
import { IPatch, Delete } from '../utilities/Graft';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { updateItems } from '../store/reducers/itemMapReducer';
import { IFaceted, pack } from '../models/Facet';
import { resolvedFacet, DemandResolution, errorFacet } from '../facets/DemandFacets';
import { readItems } from './readItems';
import { IItemCache } from '../models/IItemCacheObserver';

/**
 * @public
 */
export interface IResetItemsPayload {
    items: {
        [itemKey: string]: boolean;
    };
}

/**
 * Creates an action which, when dispatched, completely invalidates the specified items,
 * clearing all facet resolution statuses and any applicable errors.
 * @public
*/
export const resetItems: IAsyncActionCreator<IResetItemsPayload, IItemCacheThunkAction<void>> =
    createAsyncActionCreator((payload: IResetItemsPayload) => {
        const {
            items
        } = payload;

        return (dispatch: IItemCacheDispatch) => {
            dispatch(updateItems({
                items: dispatch(readItems((itemCache: IItemCache) => {
                    const pendingItems: (typeof updateItems.payloadType)['items'] = {};

                    for (const itemKey in items) {
                        if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
                            const resolved = itemCache.demandItemFacet(resolvedFacet, itemKey);

                            const demands = resolved && resolved.demands;

                            const demandResolutions: IPatch<IFaceted<DemandResolution>> = {};

                            if (demands) {
                                for (const facetId in demands) {
                                    if (Object.prototype.hasOwnProperty.call(demands, facetId)) {
                                        if (demands[facetId] === DemandResolution.failed) {
                                            demandResolutions[facetId] = new Delete<DemandResolution>();
                                        }
                                    }
                                }
                            }

                            pendingItems[itemKey] = pack({
                                resolved: resolvedFacet,
                                error: errorFacet
                            }, {
                                    resolved: {
                                        demands: demandResolutions
                                    },
                                    error: new Delete<Error>()
                                });
                        }
                    }

                    return pendingItems;
                }))
            }));
        };
    });
